import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerResponseMeetingRequestRepository } from 'application/repositorySchemas/IBuyerResponseMeetingRequestRepository';
import { type IAcceptedRequestMeetingClient } from 'interfaceAdapter/gatewaySchemas/IAcceptedRequestMeetingClient';
import { type IDeclinedMeetingRequestClient } from 'interfaceAdapter/gatewaySchemas/IDeclinedMeetingRequestClient';
import { type IBuyerBlockAgentClient } from 'interfaceAdapter/gatewaySchemas/IBuyerBlockAgentClient';

@injectable()
export class BuyerResponseMeetingRequestRepository implements IBuyerResponseMeetingRequestRepository {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IAcceptedRequestMeetingClient')
        public readonly acceptedRequestMeetingClient: IAcceptedRequestMeetingClient,
        @inject('IDeclinedMeetingRequestClient')
        public readonly declinedMeetingRequestClient: IDeclinedMeetingRequestClient,
        @inject('IBuyerBlockAgentClient')
        public readonly buyerBlockAgentClient: IBuyerBlockAgentClient,
    ) {}

    public async accepted(match_id: number) {
        const { data, message } = await this.acceptedRequestMeetingClient.post({
            token: this.buyerUserToken.get() || '',
            match_id,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async declined(match_id: number, reason: string) {
        const { data, message } = await this.declinedMeetingRequestClient.post({
            token: this.buyerUserToken.get() || '',
            match_id,
            reason,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async blockAgent(match_id: number, message: string) {
        const { data, message: errorMessage } = await this.buyerBlockAgentClient.post({
            token: this.buyerUserToken.get() || '',
            match_id,
            message,
        });

        if (errorMessage) {
            throw new Error(errorMessage);
        }

        return data;
    }
}
